import React from "react";
import { Helmet } from "react-helmet-async";

export default function NotFoundPage() {
  return (
    <div className="app page-grid">
      <Helmet>
        <title>Page not found | OptiSiteSEO</title>
        <meta name="description" content="The page you requested was not found." />
      </Helmet>
      <section className="card section">
        <p className="eyebrow">404</p>
        <h1>Page not found</h1>
        <p className="subtext">Try heading back to the homepage or run a Free SEO Scan.</p>
        <div className="cta-row">
          <a className="primary" href="/">
            Go home
          </a>
          <a className="secondary" href="/app/index.html">
            Run Free SEO Scan
          </a>
        </div>
      </section>
    </div>
  );
}
